export default __webpack_public_path__ + "volume-off.png";